function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".icon-notes_svg__cls-1{fill:var(--main-color)}.icon-notes_svg__cls-2{fill:none;stroke:var(--main-color);stroke-linecap:round;stroke-linejoin:round;stroke-width:8px}"));

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "icon-notes_svg__Layer_1",
  "data-name": "Layer 1"
}, /*#__PURE__*/React.createElement("path", {
  className: "icon-notes_svg__cls-1",
  d: "M196.09 62.21a4.6 4.6 0 014.6 4.59v130.81a4.61 4.61 0 01-4.6 4.6H65.28a4.6 4.6 0 01-4.59-4.6V66.8a4.6 4.6 0 014.59-4.59h130.81m0-8H65.28A12.59 12.59 0 0052.69 66.8v130.81a12.6 12.6 0 0012.59 12.6h130.81a12.6 12.6 0 0012.6-12.6V66.8a12.59 12.59 0 00-12.6-12.59z"
}), /*#__PURE__*/React.createElement("path", {
  className: "icon-notes_svg__cls-2",
  d: "M112.69 104.71h58M112.69 132.71h58M112.69 160.71h58"
}), /*#__PURE__*/React.createElement("path", {
  className: "icon-notes_svg__cls-1",
  d: "M65.28 206.21a8.6 8.6 0 01-8.59-8.6V66.8a8.6 8.6 0 018.59-8.59h14.41v148z"
}), /*#__PURE__*/React.createElement("path", {
  className: "icon-notes_svg__cls-1",
  d: "M75.69 62.21v140H65.28a4.6 4.6 0 01-4.59-4.6V66.8a4.6 4.6 0 014.59-4.59h10.41m8-8H65.28A12.59 12.59 0 0052.69 66.8v130.81a12.6 12.6 0 0012.59 12.6h18.41v-156z"
}));

function SvgIconNotes(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 259 259"
  }, props), _ref, _ref2);
}

export default SvgIconNotes;